import { render, staticRenderFns } from "./DeletedCompaniesTable.vue?vue&type=template&id=21ba16aa&"
import script from "./DeletedCompaniesTable.vue?vue&type=script&lang=ts&"
export * from "./DeletedCompaniesTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports